import { createAuthClient } from '@repo/auth/core';

import { AUTH_API_URL } from 'src/api/consts';
import { KEYCLOAK_CLIENT_ID, KEYCLOAK_REALM_NAME } from 'src/app/auth/consts';

export const authClient = createAuthClient({
  url: AUTH_API_URL,
  realm: KEYCLOAK_REALM_NAME,
  clientId: KEYCLOAK_CLIENT_ID,
  appStorageKey: 'dashboard',
  silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
  postLogoutRedirectUri: `${window.location.origin}/logoff`,
});
